namespace Areas.Program.Account {
    "use strict";

    let currentProgramAccount: any;



    export function onNewProgramAccountRow(e: any) {
        e.data.programId = e.component.option("ProgramId");
        currentProgramAccount = e.data;
        currentProgramAccount.ProgramProfileId = e.component.option("ProgramProfileId");
    }

    export function updateProgramAccount() {
        const grid = $("#ProgramAccountGrid").dxForm("instance");
        const newData: any = grid.option("gridData");
        const result: any = grid.validate();
        const keyId: any = grid.option("KeyId");

        if (result.isValid && keyId != null) {
            sendRequest(`/Program/Profile/Put/${keyId}`, JSON.stringify(newData), "PUT");
        }
    }

    export function onEditingProgramAccountStart(e: any) {
        currentProgramAccount = e.data;
    }

    export function editAccountTemplate(cellElement, cellInfo) {
        let accountDisplayName = !cellInfo.data.projectCCNumberName ? "Select..." : cellInfo.data.projectCCNumberName;
        let htmlString = `<div class="dx-texteditor dx-lookup-empty dx-widget dx-textbox dx-dropdowneditor dx-lookup dx-lookup-popover-mode"><input type="hidden" value=""><div class="dx-lookup-field-wrapper"><div class="dx-lookup-field" tabindex="0" role="combobox" aria-expanded="false">${accountDisplayName}</div><div class="dx-lookup-arrow" id="account-popup-button"></div></div></div>`;
        let html = $.parseHTML(htmlString);

        cellElement.on("click", selectAccount);
        cellElement.append(html);
    }



    export function selectAccount() {
        const accountDialog = new Areas.Dialogs.AccountDialog(dialogClosing);
    }



    function dialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const dataGrid = $("#ProgramAccountGrid").dxDataGrid("instance");

        var rowIndex = getItemRowIndex(dataGrid);
        updateGridItemRow(dataGrid, rowIndex, data);
    }



    export function onProgramAccountInserted(e: any) {
        currentProgramAccount = null;
    }



    function getItemRowIndex(dataGrid: DevExpress.ui.dxDataGrid): number {
        let rowIndex = 0;

        if (currentProgramAccount === undefined || currentProgramAccount === null) {
            return rowIndex;
        } else if (currentProgramAccount.programAccountId) {
            rowIndex = dataGrid.getRowIndexByKey(currentProgramAccount.programAccountId);
        }

        return rowIndex;
    }

    function updateGridItemRow(dataGrid: DevExpress.ui.dxDataGrid, rowIndex: number, data: any) {

        dataGrid.cellValue(rowIndex, "accountId", data.accountId);
        dataGrid.cellValue(rowIndex, "projectCCNumberName", data.projectCCNumberName);

        currentProgramAccount.accountId = data.accountId;
        currentProgramAccount.projectCCNumberName = data.projectCCNumberName;

        dataGrid.repaintRows([rowIndex]);
    }
}
